module.exports = __webpack_public_path__ + "static/media/meh.d5377ffa.svg";